import React, { useEffect, useState } from "react";
import axios from "axios";
import BASEURL from "../../Config/global";
import MainLayout from "../../Layout/MainLayout";
import "./style.css";
import CustomButton from "../../Components/CustomButton";
import { Modal } from "react-bootstrap";
import CustomTable from "../../Components/CustomTable";
import { crossIcon } from "../../Assets/svg";
import { Link, useNavigate } from "react-router-dom";
import { DescriptionEnjoyAndEarn, LegalForm, ShareToSocialPlatform } from "../../Components/UnCommon";
import BASEURLFrontend from "../../Config/urls";
import { useTranslation } from "react-i18next";


const Propagation = () => {
  const Navigate = useNavigate();
  const { t } = useTranslation();
  const [legalData, setLegalData] = useState({});
  const [legalFormModal, setLegalFormModal] = useState(false);
  const [propagatedUsers, setPropagatedUsers] = useState([]);
  const [shareEarnModal, setShareEarnModal] = useState(false);
  const [step, setStep] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getDataByApi();
    getPropagatedDataByApi();
  }, []);

  const getDataByApi = async () => {
    try {
      const response = await axios.get(`${BASEURL}/api/user/legal_details_and_propagation_code/${user.id}`);
      if (response.data.error != true) {
        setLegalData(response?.data?.data);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPropagatedDataByApi = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASEURL}/api/user/propagation_users/${user.id}`);
      if (response.data.error != true) {
        setPropagatedUsers(response?.data?.data);
        setLoading(false);
      } else {
        console.log(response.data.message);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const openLegalForm = () => {
    if (legalData.propagation_code) {
      setLegalFormModal(false);
    } else {
      setStep(0);
      setLegalFormModal(true);
    }
  }

  const inviteOfferCode = () => {
    setShareEarnModal(!shareEarnModal);
  }

  const headers = [
    {
      key: "id",
      title: t("shareEarn.tableHeaders.id"),
    },
    {
      key: "first_name",
      title: t("shareEarn.tableHeaders.firstName"),
    },
    {
      key: "last_name",
      title: t("shareEarn.tableHeaders.lastName"),
    },
    {
      key: "email",
      title: t("shareEarn.tableHeaders.email"),
    },
    {
      key: "date_payment",
      title: t("shareEarn.tableHeaders.dateOfPayment"),
    },
    {
      key: "payment_due_date",
      title: t("shareEarn.tableHeaders.paymentDueDate"),
    },
    {
      key: "subscription_amount",
      title: t("shareEarn.tableHeaders.subscriptionAmount"),
    },
    {
      key: "status",
      title: t("shareEarn.tableHeaders.status"),
    },
  ];

  const maskedText = (text) => {
    if (text.length <= 2) return text;
    const firstTwo = text.slice(0, 2);
    const maskedPart = '*'.repeat(text.length - 3);
    return `${firstTwo}${maskedPart}`;
  };

  const maskedEmail = (text) => {
    if (text.length <= 3) return text;
    const firstTwo = text.slice(0, 2);
    const lastOne = text.slice(-3);
    const maskedPart = '*'.repeat(text.length - 3);
    return `${firstTwo}${maskedPart}${lastOne}`;
  };

  const handleViewLegalDetailNavigation = (event) => {
    event.preventDefault();
    window.sessionStorage.setItem('path', '/share-earn');
    Navigate('/edit-profile');
  }

  return (
    <>
      <MainLayout title={t("shareEarn.title")} arrow backtoaccount>
        <div className="row align-items-center share-option-text">
          <div className="col-sm-4">
            <div className="">
              {legalData?.propagation_code != null ? (
                <div className="d-flex gap-3">
                  <Link to={""} className="text-decoration-none fw-light py-2 d-flex align-items-center  justify-content-center justify-content-sm-start" onClick={inviteOfferCode}>
                    <svg width="34" height="34" className="me-2" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M31.6199 17.3269C31.4845 17.0498 31.4845 16.732 31.6199 16.4549L32.8754 13.8866C33.5744 12.4565 33.0206 10.752 31.6145 10.006L29.0892 8.66609C28.8167 8.52158 28.63 8.26438 28.5766 7.9607L28.0828 5.14485C27.8077 3.57706 26.3575 2.52354 24.7818 2.74648L21.9512 3.14688C21.6457 3.19001 21.3435 3.09178 21.1219 2.87738L19.0673 0.889737C17.9232 -0.217038 16.131 -0.217103 14.987 0.889737L12.9323 2.87758C12.7106 3.09205 12.4085 3.19007 12.103 3.14707L9.27244 2.74668C7.69617 2.5236 6.24646 3.57725 5.97145 5.14504L5.47756 7.96076C5.42424 8.26451 5.23745 8.52165 4.96507 8.66622L2.43975 10.0061C1.03369 10.7521 0.479845 12.4567 1.17886 13.8868L2.43429 16.4551C2.56973 16.7322 2.56973 17.05 2.43429 17.3271L1.1788 19.8954C0.479779 21.3254 1.03363 23.0299 2.43968 23.7759L4.965 25.1158C5.23745 25.2604 5.42424 25.5176 5.47756 25.8212L5.97145 28.6371C6.22181 30.0643 7.44561 31.0652 8.85212 31.0651C8.99065 31.0651 9.13122 31.0554 9.27251 31.0354L12.1031 30.635C12.4083 30.5917 12.7106 30.6901 12.9323 30.9045L14.987 32.8921C15.5591 33.4456 16.293 33.7222 17.0271 33.7222C17.761 33.7221 18.4953 33.4455 19.0672 32.8921L21.1219 30.9045C21.3436 30.6901 21.6458 30.5921 21.9512 30.635L24.7818 31.0354C26.3582 31.2584 27.8077 30.2048 28.0828 28.637L28.5767 25.8213C28.63 25.5176 28.8168 25.2604 29.0892 25.1158L31.6145 23.7759C33.0206 23.03 33.5744 21.3254 32.8754 19.8953L31.6199 17.3269ZM30.7045 22.0608L28.1792 23.4007C27.3741 23.828 26.8219 24.5879 26.6644 25.4857L26.1705 28.3015C26.0775 28.832 25.5871 29.1882 25.0537 29.113L22.2231 28.7126C21.3204 28.5847 20.4272 28.8752 19.772 29.509L17.7173 31.4965C17.3303 31.8709 16.7239 31.8709 16.3368 31.4965L14.2822 29.5089C13.7285 28.9733 13.0046 28.683 12.2489 28.683C12.1105 28.683 11.9709 28.6927 11.8311 28.7125L9.00051 29.1129C8.46757 29.1882 7.97678 28.8319 7.88368 28.3015L7.38973 25.4856C7.2322 24.5878 6.68006 23.8278 5.87486 23.4007L3.34954 22.0607C2.8738 21.8083 2.68643 21.2317 2.92292 20.7478L4.17841 18.1795C4.57867 17.3605 4.57867 16.4213 4.17841 15.6023L2.92292 13.034C2.68643 12.5501 2.8738 11.9735 3.34954 11.7211L5.87486 10.3812C6.67999 9.95387 7.2322 9.19397 7.38966 8.29614L7.88355 5.48035C7.97665 4.94991 8.46698 4.59356 9.00038 4.66891L11.831 5.0693C12.7333 5.19705 13.6269 4.90665 14.2821 4.27292L16.3368 2.28527C16.7237 1.91091 17.3301 1.91091 17.7172 2.28527L19.7719 4.27292C20.427 4.90671 21.3205 5.19705 22.223 5.0693L25.0536 4.66891C25.5866 4.5935 26.0774 4.94991 26.1704 5.48035L26.6643 8.2962C26.8218 9.19404 27.3739 9.954 28.1791 10.3812L30.7045 11.7211C31.1802 11.9735 31.3676 12.5501 31.1311 13.034L29.8756 15.6023C29.4753 16.4211 29.4753 17.3605 29.8756 18.1794L31.1311 20.7477C31.3676 21.2317 31.1803 21.8084 30.7045 22.0608Z" fill="#EFB729" />
                      <path d="M24.1193 9.79784C23.7403 9.41875 23.1255 9.41875 22.7464 9.79784L9.93319 22.6112C9.5541 22.9903 9.5541 23.6049 9.93319 23.984C10.1227 24.1736 10.3712 24.2684 10.6196 24.2684C10.868 24.2684 11.1165 24.1736 11.306 23.984L24.1192 11.1708C24.4985 10.7916 24.4985 10.177 24.1193 9.79784Z" fill="#EFB729" />
                      <path d="M13.1439 8.15424C11.1813 8.15424 9.58447 9.75102 9.58447 11.7137C9.58447 13.6763 11.1813 15.2731 13.1439 15.2731C15.1066 15.2731 16.7034 13.6763 16.7034 11.7137C16.7034 9.75102 15.1066 8.15424 13.1439 8.15424ZM13.1439 13.3316C12.2518 13.3316 11.526 12.6058 11.526 11.7136C11.526 10.8215 12.2518 10.0957 13.1439 10.0957C14.036 10.0957 14.7619 10.8215 14.7619 11.7136C14.7618 12.6058 14.036 13.3316 13.1439 13.3316Z" fill="#EFB729" />
                      <path d="M20.9092 18.5089C18.9466 18.5089 17.3498 20.1056 17.3498 22.0683C17.3498 24.031 18.9466 25.6277 20.9092 25.6277C22.8719 25.6277 24.4687 24.031 24.4687 22.0683C24.4687 20.1056 22.8719 18.5089 20.9092 18.5089ZM20.9092 23.6862C20.0171 23.6862 19.2913 22.9604 19.2913 22.0683C19.2913 21.1762 20.017 20.4504 20.9092 20.4504C21.8013 20.4504 22.5271 21.1762 22.5271 22.0683C22.5271 22.9604 21.8013 23.6862 20.9092 23.6862Z" fill="#EFB729" />
                    </svg>
                    {t("shareEarn.inviteOfferCode")}
                  </Link>
                  <Link to={"/download-assets"} className="text-decoration-none d-flex align-items-center text-start gap-2">
                    <svg width="34" height="34" viewBox="0 0 32 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.466 0.81572C21.2917 0.632202 21.0529 0.522034 20.8053 0.522034H5.98152C3.24616 0.522034 0.988281 2.77092 0.988281 5.506V33.5378C0.988281 36.2731 3.24616 38.522 5.98152 38.522H26.1012C28.8365 38.522 31.0944 36.2731 31.0944 33.5378V11.2794C31.0944 11.0408 30.9843 10.8115 30.8283 10.6369L21.466 0.81572ZM21.7321 3.76215L28.0013 10.3433H23.9259C22.7144 10.3433 21.7321 9.3703 21.7321 8.15874V3.76215ZM26.1012 36.6863H5.98152C4.26521 36.6863 2.82404 35.2637 2.82404 33.5378V5.506C2.82404 3.78969 4.25594 2.35779 5.98152 2.35779H19.8964V8.15874C19.8964 10.3891 21.6956 12.179 23.9259 12.179H29.2587V33.5378C29.2587 35.2637 27.8268 36.6863 26.1012 36.6863Z" fill="#EFB729" />
                      <path d="M23.5954 30.3531H8.48721C7.98247 30.3531 7.56934 30.7659 7.56934 31.2709C7.56934 31.7757 7.98247 32.1888 8.48721 32.1888H23.6046C24.1094 32.1888 24.5225 31.7757 24.5225 31.2709C24.5225 30.7659 24.1094 30.3531 23.5954 30.3531Z" fill="#EFB729" />
                      <path d="M15.3712 27.0578C15.5457 27.2413 15.7843 27.3515 16.0411 27.3515C16.2983 27.3515 16.5369 27.2413 16.7111 27.0578L22.09 21.2844C22.4387 20.9171 22.4112 20.3297 22.0442 19.9902C21.6768 19.6414 21.0895 19.6687 20.75 20.036L16.959 24.1021V14.0791C16.959 13.5741 16.5459 13.1612 16.0411 13.1612C15.5364 13.1612 15.1233 13.5741 15.1233 14.0791V24.1021L11.3416 20.036C10.9928 19.669 10.4144 19.6414 10.0474 19.9902C9.68037 20.339 9.65283 20.9174 10.0016 21.2844L15.3712 27.0578Z" fill="#EFB729" />
                    </svg>
                    {t("shareEarn.downloadShareAssets").split(" / ").map((part, idx) => (
                      <React.Fragment key={idx}>
                        {part}
                        {idx === 0 && <br />}
                      </React.Fragment>
                    ))}
                  </Link>
                </div>
              ) : (
                <Link to={""} className="text-decoration-none fw-light py-2 d-flex align-items-center  justify-content-center justify-content-sm-start" onClick={openLegalForm}>
                  <svg width="34" height="34" className="me-2" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.6199 17.3269C31.4845 17.0498 31.4845 16.732 31.6199 16.4549L32.8754 13.8866C33.5744 12.4565 33.0206 10.752 31.6145 10.006L29.0892 8.66609C28.8167 8.52158 28.63 8.26438 28.5766 7.9607L28.0828 5.14485C27.8077 3.57706 26.3575 2.52354 24.7818 2.74648L21.9512 3.14688C21.6457 3.19001 21.3435 3.09178 21.1219 2.87738L19.0673 0.889737C17.9232 -0.217038 16.131 -0.217103 14.987 0.889737L12.9323 2.87758C12.7106 3.09205 12.4085 3.19007 12.103 3.14707L9.27244 2.74668C7.69617 2.5236 6.24646 3.57725 5.97145 5.14504L5.47756 7.96076C5.42424 8.26451 5.23745 8.52165 4.96507 8.66622L2.43975 10.0061C1.03369 10.7521 0.479845 12.4567 1.17886 13.8868L2.43429 16.4551C2.56973 16.7322 2.56973 17.05 2.43429 17.3271L1.1788 19.8954C0.479779 21.3254 1.03363 23.0299 2.43968 23.7759L4.965 25.1158C5.23745 25.2604 5.42424 25.5176 5.47756 25.8212L5.97145 28.6371C6.22181 30.0643 7.44561 31.0652 8.85212 31.0651C8.99065 31.0651 9.13122 31.0554 9.27251 31.0354L12.1031 30.635C12.4083 30.5917 12.7106 30.6901 12.9323 30.9045L14.987 32.8921C15.5591 33.4456 16.293 33.7222 17.0271 33.7222C17.761 33.7221 18.4953 33.4455 19.0672 32.8921L21.1219 30.9045C21.3436 30.6901 21.6458 30.5921 21.9512 30.635L24.7818 31.0354C26.3582 31.2584 27.8077 30.2048 28.0828 28.637L28.5767 25.8213C28.63 25.5176 28.8168 25.2604 29.0892 25.1158L31.6145 23.7759C33.0206 23.03 33.5744 21.3254 32.8754 19.8953L31.6199 17.3269ZM30.7045 22.0608L28.1792 23.4007C27.3741 23.828 26.8219 24.5879 26.6644 25.4857L26.1705 28.3015C26.0775 28.832 25.5871 29.1882 25.0537 29.113L22.2231 28.7126C21.3204 28.5847 20.4272 28.8752 19.772 29.509L17.7173 31.4965C17.3303 31.8709 16.7239 31.8709 16.3368 31.4965L14.2822 29.5089C13.7285 28.9733 13.0046 28.683 12.2489 28.683C12.1105 28.683 11.9709 28.6927 11.8311 28.7125L9.00051 29.1129C8.46757 29.1882 7.97678 28.8319 7.88368 28.3015L7.38973 25.4856C7.2322 24.5878 6.68006 23.8278 5.87486 23.4007L3.34954 22.0607C2.8738 21.8083 2.68643 21.2317 2.92292 20.7478L4.17841 18.1795C4.57867 17.3605 4.57867 16.4213 4.17841 15.6023L2.92292 13.034C2.68643 12.5501 2.8738 11.9735 3.34954 11.7211L5.87486 10.3812C6.67999 9.95387 7.2322 9.19397 7.38966 8.29614L7.88355 5.48035C7.97665 4.94991 8.46698 4.59356 9.00038 4.66891L11.831 5.0693C12.7333 5.19705 13.6269 4.90665 14.2821 4.27292L16.3368 2.28527C16.7237 1.91091 17.3301 1.91091 17.7172 2.28527L19.7719 4.27292C20.427 4.90671 21.3205 5.19705 22.223 5.0693L25.0536 4.66891C25.5866 4.5935 26.0774 4.94991 26.1704 5.48035L26.6643 8.2962C26.8218 9.19404 27.3739 9.954 28.1791 10.3812L30.7045 11.7211C31.1802 11.9735 31.3676 12.5501 31.1311 13.034L29.8756 15.6023C29.4753 16.4211 29.4753 17.3605 29.8756 18.1794L31.1311 20.7477C31.3676 21.2317 31.1803 21.8084 30.7045 22.0608Z" fill="#EFB729" />
                    <path d="M24.1193 9.79784C23.7403 9.41875 23.1255 9.41875 22.7464 9.79784L9.93319 22.6112C9.5541 22.9903 9.5541 23.6049 9.93319 23.984C10.1227 24.1736 10.3712 24.2684 10.6196 24.2684C10.868 24.2684 11.1165 24.1736 11.306 23.984L24.1192 11.1708C24.4985 10.7916 24.4985 10.177 24.1193 9.79784Z" fill="#EFB729" />
                    <path d="M13.1439 8.15424C11.1813 8.15424 9.58447 9.75102 9.58447 11.7137C9.58447 13.6763 11.1813 15.2731 13.1439 15.2731C15.1066 15.2731 16.7034 13.6763 16.7034 11.7137C16.7034 9.75102 15.1066 8.15424 13.1439 8.15424ZM13.1439 13.3316C12.2518 13.3316 11.526 12.6058 11.526 11.7136C11.526 10.8215 12.2518 10.0957 13.1439 10.0957C14.036 10.0957 14.7619 10.8215 14.7619 11.7136C14.7618 12.6058 14.036 13.3316 13.1439 13.3316Z" fill="#EFB729" />
                    <path d="M20.9092 18.5089C18.9466 18.5089 17.3498 20.1056 17.3498 22.0683C17.3498 24.031 18.9466 25.6277 20.9092 25.6277C22.8719 25.6277 24.4687 24.031 24.4687 22.0683C24.4687 20.1056 22.8719 18.5089 20.9092 18.5089ZM20.9092 23.6862C20.0171 23.6862 19.2913 22.9604 19.2913 22.0683C19.2913 21.1762 20.017 20.4504 20.9092 20.4504C21.8013 20.4504 22.5271 21.1762 22.5271 22.0683C22.5271 22.9604 21.8013 23.6862 20.9092 23.6862Z" fill="#EFB729" />
                  </svg>
                  {t("shareEarn.title")}
                </Link>
              )}
            </div>
          </div>
          <div className="col-sm-8 text-end">
            {
              legalData?.propagation_code != null && (
                <div className="d-flex justify-content-center justify-content-sm-end align-items-center gap-5">

                  <Link to={"/edit-profile"} className="text-decoration-none d-flex align-items-center text-start gap-2">
                    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_117_24)">
                        <circle cx="18.0022" cy="18.7117" r="16.6615" stroke="#EFB729" strokeWidth="2" />
                        <path d="M21.0718 17.1974C20.2015 16.714 19.2792 16.3569 18.3644 15.9776C17.8363 15.7619 17.3305 15.5016 16.8842 15.1446C16.0065 14.4379 16.1701 13.2999 17.204 12.8462C17.4941 12.7198 17.7991 12.6751 18.1115 12.6603C19.309 12.5933 20.4396 12.8165 21.5255 13.3371C22.0611 13.5974 22.2396 13.5156 22.4255 12.9578C22.6189 12.3627 22.7825 11.7603 22.9536 11.1652C23.0726 10.7636 22.9239 10.4958 22.5445 10.3322C21.8528 10.0272 21.1387 9.80406 20.3875 9.69249C19.4131 9.53629 19.4131 9.53629 19.4057 8.55447C19.3982 7.16356 19.3982 7.16356 18.0148 7.171C17.8139 7.171 17.6131 7.16356 17.4123 7.171C16.7652 7.19331 16.6536 7.30488 16.6387 7.95199C16.6313 8.24207 16.6387 8.5396 16.6387 8.82968C16.6313 9.69993 16.6313 9.68505 15.7982 9.98257C13.79 10.7115 12.5478 12.0801 12.4139 14.2743C12.2949 16.2156 13.3065 17.5247 14.8982 18.4768C15.8801 19.0644 16.966 19.414 18.0073 19.8751C18.4164 20.0536 18.8032 20.2619 19.1379 20.5446C20.142 21.3702 19.9561 22.7462 18.766 23.2669C18.1263 23.5421 17.4569 23.6165 16.7726 23.5272C15.709 23.3933 14.69 23.1181 13.7379 22.6198C13.1801 22.3297 13.0164 22.4041 12.823 23.014C12.6594 23.5421 12.5106 24.0702 12.3693 24.5983C12.1759 25.3123 12.2429 25.4834 12.9272 25.8107C13.79 26.2272 14.7197 26.4429 15.6644 26.5991C16.4007 26.7181 16.4305 26.7479 16.4379 27.514C16.4379 27.8636 16.4454 28.2131 16.4454 28.5553C16.4528 28.9941 16.6611 29.247 17.1148 29.2545C17.628 29.2619 18.1412 29.2619 18.6544 29.2545C19.071 29.247 19.2867 29.0165 19.2941 28.5925C19.2941 28.1165 19.3164 27.6404 19.3016 27.1644C19.2792 26.6809 19.4875 26.4355 19.9561 26.309C21.0272 26.0189 21.942 25.4388 22.6487 24.5834C24.5825 22.2032 23.8387 18.7297 21.0718 17.1974Z" fill="#EFB729" />
                      </g>
                      <defs>
                        <clipPath id="clip0_117_24">
                          <rect width="36" height="36" fill="white" transform="translate(0 0.209015)" />
                        </clipPath>
                      </defs>
                    </svg>

                    {t("shareEarn.editFinancial")} <br /> {t("shareEarn.contact")}
                  </Link>
                </div>
              )
            }
          </div>
          <div className="col-md-12 mt-5">
            <CustomTable headers={headers}>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8} className="text-center">
                      <div class="spinner-border spinner-border-sm text-white my-3" role="status"></div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {propagatedUsers.length > 0 && propagatedUsers.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.first_name ? maskedText(item?.first_name) : ''}</td>
                        <td>{item?.last_name ? maskedText(item?.last_name) : ''}</td>
                        <td>{item?.email ? maskedEmail(item?.email) : ''}</td>
                        <td>{item?.date_of_payment ? item?.date_of_payment : '-'}</td>
                        <td>{item?.payment_due_date ? item?.payment_due_date : '-'}</td>
                        <td>USD {item?.subscription_amount}</td>
                        <td>{item?.status}</td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </CustomTable>
          </div>
        </div>
      </MainLayout>

      {/* Legal Form Modal */}
      <Modal
        show={legalFormModal}
        centered
        className="legal-form-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="modal-wrapper d-flex flex-column position-relative">
            <div className="save-mix-header text-end position-absolute top-0 w-100">
              <button
                className="notButton ms-auto d-flex align-items-center p-4 pb-0"
                onClick={() => setLegalFormModal(false)}
              >
                <img src={crossIcon} alt="Close Button" className="img-fluid" style={{ width: '15px' }} />
              </button>
            </div>
            <div className="d-flex flex-column justify-content-between flex-grow-1">
              {/* Step 1 for Description */}
              {
                step === 0 ? (
                  <DescriptionEnjoyAndEarn stepNext={() => { setStep(step + 1) }} />
                ) : (<></>)
              }
              {/* Step 2 for Legal Form */}
              {
                step === 1 ? (
                  <LegalForm submit={() => { setLegalFormModal(false); getDataByApi(); }} stepBack={() => { setStep(step - 1) }} stepNext={() => { setStep(step + 1) }} />
                ) : (<></>)
              }
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Invite Share & Earn Modal */}
      <Modal
        show={shareEarnModal}
        centered
        className="soundModal mixer-modal share-earn-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="modal-wrapper d-flex flex-column">
            <div className="save-mix-header text-end">
              <button
                className="notButton ms-auto d-flex align-items-center p-4"
                onClick={() => setShareEarnModal(false)}

              >
                <img src={crossIcon} alt="Close Button" className="img-fluid" style={{ width: '15px' }} />
              </button>
            </div>
            <div className="d-flex flex-column justify-content-between flex-grow-1">
              <div className="p-4">
                <ShareToSocialPlatform url={`${BASEURLFrontend}/promo/${legalData?.propagation_code}`} showPlatforms={true} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Propagation;

const DownloadAssets = ({ stepBack, stepNext }) => {

  return (
    <>
      <div className="d-flex justify-content-between">
        <CustomButton
          variant="primaryButton"
          text="Back"
          onClick={stepBack}
          type="button"
        />
        <CustomButton
          variant="primaryButton"
          text="Next"
          type="button"
          onClick={stepNext}
        />
      </div>
    </>
  )
}
